import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from "../../models/field.interface";
import * as _ from 'lodash';
import { ValidationService, ValidationType } from '../../services/validation.service';
@Component({
  selector: 'app-check-box-list',
  template: `
<div *ngIf="field.style.visibility" class="hazard-description">
  <div class="select-style">
    <p class="dynamic-paragraph">{{field.name}} <b *ngIf="field.validation.isRequired">*</b></p>
    <div class="checbox-list">
      <ng-multiselect-dropdown [placeholder]="'Select'" [ngClass]="{'pointer-events' : !field.style.editability}" [data]="dropdownList" [(ngModel)]="selectedTaskStatusList" [settings]="dropdownSettings" (onSelect)="onItemSelect($event)" (onDeSelect)="onItemDeSelect($event)">
      </ng-multiselect-dropdown>
    </div>
  </div>
  <span class="error-message" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span>
</div>
`,
  styles: [
    ` .select-style {background: url(assets/rff-images/select-bg.png) no-repeat 96% 80%!important;width:100%;display:inline-block}`
  ]
})
export class CheckBoxListComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  selectedTaskStatusList = [];
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  constructor(
    private _validationService: ValidationService
  ) { }
  ngOnInit() {
    if (this.field.value && this.field.value !== " ") {
     _.forEach(this.field.value , (key,value)=>{
      var dropObj = {
        id: value,
        name: key
      }
      this.selectedTaskStatusList.push(dropObj);
     })
    }
    for (const obj of this.field.data) {
      for (let key in obj) {
        var dropObj = {
          id: key,
          name: obj[key]
        }
        this.dropdownList.push(dropObj);
      }
    }
    this.selectedItems = [];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 30,
      allowSearchFilter: true
    };
  }
  onItemSelect(item: any) {
    if (!this.field.value) {
      this.field.value = {};
    }
    if(item.name && item.id){
      this.selectedItems.push(this.field.data[item.id]);
      this.field.value[item.id] = item.name;
    }else{
      this.selectedItems.push(this.field.data[item]);
      this.field.value[item.id] = item;
    }
    this.group.value[this.field.id] = this.field.value;
    const data = this.group.value;
    this._validationService.applyValidation(this.field, data, [ValidationType.isRequired, ValidationType.onChange]);
  }
  onSelectAll(items: any) {
    if (!this.field.value) {
      this.field.value = {};
    }
    this.selectedItems = [];
    this.selectedItems = this.field.data;
    _.forEach(items, (item) => {
      this.field.value[item.id] = item.name;
    })
  }
  onItemDeSelect(item: any) {
    this.selectedItems.splice(this.field.data);
    delete this.field.value[item.id];
  }
}


// WEBPACK FOOTER //
// ./src/app/rFF/fields/check-box-list/check-box-list.component.ts